import cookiesService from "./services/cookies.service";
if (process.env.NODE_ENV !== 'production') {
    console.warn('CMS Plugin - Public: Development mode!');
}
document.addEventListener('DOMContentLoaded', function () {
    cookiesService.initialize();
});
